import React, {Component} from "react";
import PropTypes from "prop-types";

export default class HorizontalScroll extends Component {
  static propTypes = {
    children: PropTypes.element,
    withArrows: PropTypes.bool,
    onScroll: PropTypes.func
  };
  state = {
    scrollLeft: 0,
    isVisibleScroll: true
  };
  static defaultProps = {
    withArrows: true,
    onScroll: () => {}
  };
  scrollWrapper = React.createRef();
  wheel = (e) => {
    const delta =
      Math.abs(e.wheelDeltaY) > Math.abs(e.wheelDeltaX)
        ? e.wheelDeltaY
        : e.wheelDeltaX;
    e.currentTarget.scrollLeft -= delta / 2;
    this.setState({
      scrollLeft: e.currentTarget.scrollLeft
    });
    this.props.onScroll();
    e.preventDefault();
  };
  changeScrollLeft = (direction) => () => {
    const scrollLeft = this.scrollWrapper.current.scrollLeft + direction * 1170; // 1 item = 130
    this.setState({
      scrollLeft
    });
    this.scrollWrapper.current.scrollLeft = scrollLeft;
  };
  componentDidMount() {
    if (this.scrollWrapper.current) {
      this.scrollWrapper.current.addEventListener(`mousewheel`, this.wheel);
      this.scrollWrapper.current.addEventListener(`DOMMouseScroll`, this.wheel);
    }
  }
  componentDidUpdate() {
    const isVisibleScroll = this.checkScroll();
    if (this.state.isVisibleScroll !== isVisibleScroll) {
      this.setState({
        isVisibleScroll
      });
    }
  }
  componentWillUnmount() {
    this.scrollWrapper.current.removeEventListener(`mousewheel`, this.wheel);
    this.scrollWrapper.current.removeEventListener(
      `DOMMouseScroll`,
      this.wheel
    );
  }
  checkScroll() {
    let result = true;
    if (
      this.scrollWrapper.current.scrollLeft === 0 &&
      this.scrollWrapper.current.scrollTo
    ) {
      this.scrollWrapper.current.scrollTo(1, 0);
      result = this.scrollWrapper.current.scrollLeft;
      this.scrollWrapper.current.scrollTo(0, 0);
    }
    return !!result;
  }
  render() {
    const {children, withArrows} = this.props;
    const {isVisibleScroll} = this.state;
    return (
      <div className="horizontal-scroll" ref={this.scrollWrapper}>
        {isVisibleScroll && withArrows && (
          <button
            className="horizontal-scroll__control horizontal-scroll__control_left"
            onClick={this.changeScrollLeft(-1)}
          />
        )}
        <div className="horizontal-scroll__content">{children}</div>
        {isVisibleScroll && withArrows && (
          <button
            className="horizontal-scroll__control horizontal-scroll__control_right"
            onClick={this.changeScrollLeft(1)}
          />
        )}
      </div>
    );
  }
}
